// import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { useForm, Controller } from 'react-hook-form';
import { FomrDiv, Label } from '../../layout/Login/Login.style';
import { Link, useNavigate } from 'react-router-dom';
import './LoginForm.css';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import { signIn } from '../../features/auth/authSlice';

import { UserCredentials } from '../../features/auth/UserCredentials.interface';
import { LoginResponse } from '../../features/auth/LoginResponse.interface';
import { login } from '../../features/auth/auth.api';
import { loadingSelector, setLoading } from '../../features/loading/loadingSlice';
import { classNames } from 'primereact/utils';
import { toast } from 'react-toastify';

const LoginForm = () => {
  
  const defaultValues: any = {
    email: '',
    password: '',
  };

  //navigator to navigate to home if login sucess
  const navigate = useNavigate();

  //store actions to store creadentials to the store
  const dispatch = useAppDispatch();

  //selectors
  const isLoading = useAppSelector(loadingSelector);

  //hook form to genrate form data
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });

  //form on submit
  /**
   * @todo
   * make axios call
   * send the data to store from dispatch
   * send the token to localStorage
   * navigate to my home if signIn successful
   * @param
   * email && password
   */
  const onSubmit = async (data: UserCredentials) => {
    dispatch(setLoading(true));
    setLoading(true);

    await login(data)
      .then((res: LoginResponse) => {
        dispatch(signIn(res.token.access_token));
        localStorage.setItem('userToken', res.token.access_token);
        localStorage.setItem('one_file_size_max', res.user.one_file_size_max);
        localStorage.setItem('one_video_size_max', res.user.one_video_size_max);


        if(res?.user?.first_login_flag){
          navigate('/changePassword')
        }else{
          navigate('/');
        }
        dispatch(setLoading(false));
        setLoading(false);
      })
      .catch((err: any) => {
        toast.error(err.response?.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        dispatch(setLoading(false));
      });
  };

  const getFormErrorMessage = (name: string) => {
    return (
      errors[`${name}`] && (
        <small className="p-error">
          {errors ? errors[`${name}`]?.message : null}
        </small>
      )
    );
  };

  return (
    <FomrDiv>
      <div className="" style={{ position: 'relative' }}>
        <div className="card">
        <p className='title'>SIGN IN</p>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="p-field">
              <Label
                className={classNames({
                  'p-error': errors[`email`],
                })}
                htmlFor="email"
              >
                Email
              </Label>
              <Controller
                name="email"
                control={control}
                rules={{ required: '*Required' }}
                render={({ field, fieldState }) => (
                  <InputText

                    type="email"
                    disabled={isLoading ? true : false}
                    id={field.name}
                    style={{color:'#616161', opacity:'0.71'}}
                    {...field}
                    className={classNames({
                      'p-invalid': fieldState.invalid,
                    })}
                    placeholder="Enter Your Email"
                  />
                )}
              />
              {getFormErrorMessage('email')}
            </div>
            <div className="p-field">
              <Label
                className={classNames({
                  'p-error': errors[`password`],
                })}
                htmlFor="password"
              >
                Password
              </Label>
              <Controller
                name="password"
                control={control}
                rules={{ required: '*Required', minLength: {value:6 , message: 'At least 6 digits'} }}
                render={({ field, fieldState }) => (
                  <Password
                    disabled={isLoading ? true : false}
                    style={{color:'#616161', opacity:'0.71'}}
                    id={field.name}
                    {...field}
                    className={classNames({
                      'p-invalid': fieldState.invalid,
                    })}
                    placeholder="Enter Your Password"
                    toggleMask
                  />
                )}
              />
              {getFormErrorMessage('password')}
            </div>
            <div className="forg_pass-container">
              <Link to='/forgotPassword' type="button" className='forgot_pass-btn'>Forgot password?</Link>
            </div>


            <Button
              type="submit"
              label="Login"
              className="p-mt-2 submit-btn"
              disabled={isLoading ? true : false}
            >
            </Button>
          </form>
        </div>
      </div>
    </FomrDiv>
  );
};

export default LoginForm;
